import type { Component } from 'vue'
import { LoaderIcon } from '@solar-icons/vue/linear'
import {
  CheckCircleIcon,
  CloseCircleIcon,
  DangerTriangleIcon,
  InfoCircleIcon,
} from '@solar-icons/vue/bold'

/** Where a notice lives: the page flow, a standalone block, the content sheet's top strip, or a floating stack. */
export type NoticeShape = 'inline' | 'card' | 'banner' | 'toast'

export type NoticeTone = 'neutral' | 'info' | 'progress' | 'success' | 'warning' | 'error'

interface NoticeToneEntry {
  /** The tint painted on the notice's surface (or, on a toast, its inner wash span). */
  washClass: string
  /** The bare glyph shown when `icon` is not set. */
  glyph: Component
  /** The bare glyph's ink. */
  inkClass: string
  titleClass: string
}

/** The one tone table AppNotice reads; a tone changes here, once, for every shape. */
export const NOTICE_TONE_TABLE: Record<NoticeTone, NoticeToneEntry> = {
  neutral: {
    washClass: 'bg-bg-wash',
    glyph: InfoCircleIcon,
    inkClass: 'text-icon-secondary',
    titleClass: 'text-text-primary',
  },
  info: {
    washClass: 'bg-accent-blue-wash',
    glyph: InfoCircleIcon,
    inkClass: 'text-accent-blue-ink',
    titleClass: 'text-accent-blue-ink',
  },
  progress: {
    washClass: 'bg-accent-blue-wash',
    glyph: LoaderIcon,
    inkClass: 'text-accent-blue-ink',
    titleClass: 'text-accent-blue-ink',
  },
  success: {
    washClass: 'bg-accent-green-wash',
    glyph: CheckCircleIcon,
    inkClass: 'text-accent-green-ink',
    titleClass: 'text-accent-green-ink',
  },
  warning: {
    washClass: 'bg-accent-orange-wash',
    glyph: DangerTriangleIcon,
    inkClass: 'text-accent-orange-ink',
    titleClass: 'text-accent-orange-ink',
  },
  error: {
    washClass: 'bg-accent-red-wash',
    glyph: CloseCircleIcon,
    inkClass: 'text-accent-red-ink',
    titleClass: 'text-accent-red-ink',
  },
}
